import { render } from "./VerExpediente.vue?vue&type=template&id=7ffd6972&scoped=true"
import script from "./VerExpediente.vue?vue&type=script&lang=js"
export * from "./VerExpediente.vue?vue&type=script&lang=js"

import "./VerExpediente.vue?vue&type=style&index=0&id=7ffd6972&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ffd6972"]])

export default __exports__